import { useNavigate } from "react-router-dom";

export const useSidebar = () => {
  const navigate = useNavigate();

  const switchView = async (url: string) => {
    await navigate(url);
  };

  return { switchView };
};
